import React, { useEffect, useState } from "react";
import { useStockData } from "./store";
import StockDataTable from "./StockDataTable";
import { Button } from "react-bootstrap";
import CardDiv from "modules/common/card-div/CardDiv";
import Search from "antd/es/input/Search";
import { UserOutlined } from "@ant-design/icons";
import { isDownloadDisabled } from "modules/utilities/utility";

function StockData() {
  const { stocksData, stockReportLoading, fetchStockReport } = useStockData();
  const [searchText, setSearchText] = useState(null);
  const [originalData, setOriginalData] = useState([]);

  useEffect(() => {
    setOriginalData(stocksData?.mainData);
  }, [stocksData]);
  
  useEffect(() => {
    if(searchText){
      fetchStockReport("","",searchText);
    }
    else{
      setOriginalData([]);
    }
  }, [searchText]);


  const handleSearch = (value) => {
    setSearchText(value);
  };

  return (
    <div className="d-flex flex-column gap-3">
      <CardDiv
        title={<div className="fs-2">Stock Data</div>}
        component={
          <div style={{ height: "70vh" }}>
            <div className="d-flex justify-content-between">
              <Search
                placeholder="Search with Order Id"
                allowClear
                enterButton="Search"
                onSearch={handleSearch}
                prefix={<UserOutlined />}
                style={{ width: "35%" }}
              />
              <Button className="btn btn-primary" disabled={isDownloadDisabled} >Download</Button>
            </div>
            {originalData && (
              <div className="mt-5">
                <StockDataTable
                  isLoading={stockReportLoading}
                  stocksData={originalData}
                />
              </div>
            )}
          </div>
        }
      />
    </div>
  );
}

export default StockData;
